import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { OtpNode } from './otp';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { ClickatellChipComponent } from '../../../../../../../shared/components/clickatell-chip/clickatell-chip.component';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'otp';

@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, ClickatellChipComponent, CMSComponent, NextSelectorComponent]
})
export class OtpComponent extends NodeBuilder implements OnInit {

  otpForm: UntypedFormGroup;

  readonly KEYWORD_FIELD = {
    dataType: 'keyword',
    type: 'chips',
    label: '',
    placeholder: 'Add keyword(s)',
    validators: {
      maxLength: 5,
      duplicate: true,
    },
  };

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.otpForm = OtpNode.toForm(stepData, this.canEdit);
  }

  get getStepData(): {} {
    const nodeData = new OtpNode();
    nodeData.setMenuData(this.otpForm.getRawValue());
    return nodeData.nodeData;
  }

  get isNodeValid(): boolean {
    this.otpForm.markAllAsTouched();
    return this.otpForm.valid;
  }

}
